module.exports = __webpack_public_path__ + "img/white_paper20.7e3b2b93.png";